import React from 'react';
import { CheckIcon, PlusIcon } from 'lucide-react';
import { useAppState } from '../contexts/AppStateContext';
import { useUi } from '../contexts/UiContext';
import { schoolKindLabels } from '../data/labels';
import { formatDate } from '../utils/time';
import { PageHeader } from '../components/ui/PageHeader';
import { Panel } from '../components/ui/Panel';
import { Button } from '../components/ui/Button';
import { Avatar } from '../components/Avatar';
export function ProfilePage() {
  const {
    viewer,
    isAdmin,
    family,
    db,
    myFamilies,
    switchFamily,
    toggleSchoolItem,
    deleteSchoolItem
  } = useAppState();
  const {
    openSub,
    setTab
  } = useUi();
  const own = db.schoolItems.filter(s => s.familyId === family.id && s.memberId === viewer.id && s.createdBy === viewer.id);
  const r = family.rules;
  return <div data-id="element-1549" data-mp="2bjj6j20ew067">
      <PageHeader title="Moj profil" onBack={() => openSub(null)} data-id="element-1550" data-mp="2bjszmygr6ng4" />
      <div className="grid gap-6 lg:grid-cols-2" data-id="element-1551" data-mp="2gk6xjnon4h0f">
        <Panel data-id="element-1552" data-mp="2gkytizm5ggr8">
          <div className="flex items-center gap-4" data-id="element-1553" data-mp="2ghaz7y8vrqbg">
            <Avatar member={viewer} size="lg" className="h-16 w-16 text-2xl" data-id="element-1554" data-mp="2a6pvn5q0hr2f" />
            <div data-id="element-1555" data-mp="264l4cdn1d6iy">
              <p className="font-display text-2xl font-semibold" data-id="element-1556" data-mp="2654h7fxtx4q4">{viewer.name}</p>
              <p className="text-sm text-muted" data-id="element-1557" data-mp="2k449cxkjw1r1">
                {isAdmin ? 'Skrbnik' : 'Otrok'} · Družina {family.name}
                {viewer.birth ? ` · ${viewer.birth}` : ''}
              </p>
            </div>
          </div>
          {!isAdmin && <p className="mt-3 text-xs text-muted" data-id="element-1558" data-mp="2t2ppkm2jv4on">Ime in sliko ureja skrbnik.</p>}
        </Panel>

        <Panel title="Moje družine" hint="Vsaka družina ima svoje člane, pravila in zgodovino." data-id="element-1559" data-mp="2p2oya0ucqz06">
          <ul className="space-y-2" data-id="element-1560" data-mp="32tk9vkw8ju7g">
            {myFamilies.map(f => <li key={f.id} data-id="element-1561" data-mp="2xwk47b3astgv">
                <button type="button" onClick={() => switchFamily(f.id)} aria-pressed={f.id === family.id} className={`flex w-full items-center justify-between rounded-2xl border-[1.5px] px-3 py-2.5 text-left font-bold ${f.id === family.id ? 'border-done bg-done-soft' : 'border-line hover:bg-canvas'}`} data-id="element-1562" data-mp="2xxc06n0t4t7o">
                  Družina {f.name}
                  {f.id === family.id && <CheckIcon className="h-4 w-4 text-done" aria-hidden="true" data-id="element-1563" data-mp="3ouj52u1k4kqb" />}
                </button>
              </li>)}
          </ul>
          <Button variant="secondary" className="mt-3" onClick={() => openSub({
          kind: 'wizard'
        })} data-id="element-1564" data-mp="3tnm0l7pwa495">
            <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-1565" data-mp="2hkocvu714lx" /> Ustvari novo družino
          </Button>
        </Panel>

        <Panel title="Moje vsebine" hint="Lastne vsebine lahko urejaš in brišeš. Obveznosti, ki jih določi skrbnik, ostanejo nespremenjene." action={<Button size="sm" variant="secondary" onClick={() => {
        openSub(null);
        setTab('koledar');
      }} data-id="element-1567" data-mp="gcn40aoue8bx">
              Dodaj v Koledar › Šola
            </Button>} data-id="element-1566" data-mp="bfwl7flnkymt">
          {own.length === 0 ? <p className="text-sm text-muted" data-id="element-1568" data-mp="25welps5cn8r1">Še nisi dodal(a) svojih TODO ali testov.</p> : <ul className="divide-y divide-line" data-id="element-1569" data-mp="20ws4z8qbbadh">
              {own.map(s => <li key={s.id} className="flex items-center gap-3 py-2 text-sm" data-id="element-1570" data-mp="1vxyulp6bnzhj">
                  <button type="button" onClick={() => toggleSchoolItem(s.id)} aria-pressed={s.done} aria-label={`${s.title}: preklopi opravljeno`} className={`grid h-6 w-6 place-items-center rounded-md border-2 ${s.done ? 'border-done bg-done text-white' : 'border-[#C9BBA4] text-transparent'}`} data-id="element-1571" data-mp="1vvuhqhqg3q54">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3.5} aria-hidden="true" data-id="element-1572" data-mp="2jpm9t9u81m3z" />
                  </button>
                  <span className={`min-w-0 flex-1 ${s.done ? 'text-muted line-through' : 'font-semibold'}`} data-id="element-1573" data-mp="188cr4pix2y3q">
                    {schoolKindLabels[s.kind]}: {s.title} · {formatDate(s.date)}
                  </span>
                  <Button size="sm" variant="ghost" onClick={() => deleteSchoolItem(s.id)} data-id="element-1574" data-mp="2s2xgrj3ayexy">
                    Izbriši
                  </Button>
                </li>)}
            </ul>}
        </Panel>

        <Panel title="Obvestila in opomniki" hint="Družinske privzete vrednosti. V aplikaciji jih boš lahko utišal(a)." data-id="element-1575" data-mp="2i6m24mg8pd0c">
          <ul className="space-y-1.5 text-sm" data-id="element-1576" data-mp="2n4nkt69r7aba">
            <li data-id="element-1577" data-mp="3atf9hno4xajb">Pregled preostalih nalog ob {r.reminders.dailySummary}</li>
            {family.modules.vecerniRezim && <li data-id="element-1578" data-mp="3ftbbxih6otwr">Večerna rutina {r.reminders.eveningMinutesBefore} min pred rokom</li>}
            <li data-id="element-1579" data-mp="30wainajcgqw6">Opomniki dogodkov po nastavitvi dogodka</li>
          </ul>
        </Panel>
      </div>
    </div>;
}